<template>
  <div class="bg-black-80 h-100" id="mainOuterDiv" ref="myOuterDiv">
    <template v-if="shouldShowCloud">
      <div class>
        <div id="gohomelinkbar">
          <p class="tc bg-black pa2 ma0">
            <a v-on:click="showCloud" class="link blue" href="#">Back to home</a>
          </p>
        </div>
        <div class="ma3" style="height: 85vh">
          <vue-word-cloud
            :words="calculatedWords"
            :color="pickRandomColor"
            :animationDuration="1000"
            :rotation="0"
            font-family="Avenir"
          ></vue-word-cloud>
        </div>
        <!-- <canvas id="my_canvas"></canvas> -->
        <!-- <div id="my_canvas" class="canvas center pb2 pt2 mt3 mb3" style="width: 800px; height: 600px; background-color: rgb(255, 224, 224); position: relative;">...</div> -->
      </div>
      <!-- end topbar-and-wordcloud -->
    </template>
    <template v-else ref="defaultPage">
      <div id="mainArea" ref="mainArea">
        <div class="tc">
          <h1
            class="f-subheadline fw2 white-90 mt0 pt2 mb0 lh-title b avenir"
            ref="myHeadline"
          >Daniel's Brain</h1>
          <span class="center f4 white-90 lh-title db pb1">Pearls of wisdom</span>
          <div class="k--group">
            <input
              id="searchBox"
              class="pa3 bn br2 br--left k--input"
              v-model="txtInput"
              type="text"
              placeholder="search"
            >
            <button
              v-on:click="filterQuotes"
              class="pa3 bn br2 br--right bg-blue btn-clicky white"
              href="#"
            >Ask Daniel</button>
          </div>
          <button
            v-on:click="showRandomQuote"
            class="pa3 ma2 bn br2 bg-blue white btn-clicky"
            href="#"
          >Random Quote</button>
        </div>
        <transition name="fade" v-if="isLoading">
          <div class="center w-100 tc mt2 mb2 vh-25 v-mid">
            <pulse-loader></pulse-loader>
          </div>
          <!-- <span class="fw4 f3-l b f3-ns f4-m gray tc overflow-y-hidden ph1">Booting up the Brain</span> -->
        </transition>
        <!-- <transition name="fade" v-if="!isLoading">
      <div class="flex items-center mw6 ma3 center br3 bg-near-white shadow-1 tc ">
          <div class="flex-column w-25 h-100 mt2 mb2"><img v-bind:class="{ 'be-spinning' : shouldBeSpinning}" class="mw4 mw3-ns mw4-l mw4-m h-100 " src="static/daniel_icon.svg"/></div>
          <div class="flex-column w-75 h-75 v-mid pl2 pr2 pt3 pb3">
                <span class="fw4 f3-l b f3-ns f4-m gray tc overflow-y-hidden ph1">"{{ quote }}"</span>
          </div>
      </div>
        </transition>-->
        <transition name="fade" v-if="!isLoading">
          <div class="flex items-center mw6 ma3 tc center">
            <div class="flex-column w-25 h-100 mt2 mb2">
              <img
                v-bind:class="{ 'be-spinning' : shouldBeSpinning}"
                class="mw4 mw3-ns mw4-l mw4-m h-100"
                src="static/daniel_icon.svg"
              >
            </div>
            <div class="flex-column w-75 v-mid pl3 pr2 pt3 pb3">
              <hgroup class="speech-bubble mw6 flex items-center center pa2">
                <span
                  class="fw4 f3-l b f3-ns f4-m white justify-center tc overflow-y-hidden ma2 pa2"
                >{{ quote }}</span>
              </hgroup>
            </div>
          </div>
        </transition>
        <section>
          <sub-menu v-bind:onClick="showCloud"></sub-menu>
        </section>
      </div>
    </template>
  </div>
</template>
<script>
import VueWordCloud from "vuewordcloud";
import SubMenu from "./Submenu.vue";
const request = require("request-json");
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
// import WordCloud from 'wordcloud'
// var PulseLoader = VueSpinner.PulseLoader

export default {
  name: "DanielsBrain",
  components: { SubMenu, [VueWordCloud.name]: VueWordCloud, PulseLoader },
  data() {
    return {
      isLoading: true,
      quote: "",
      quotes: [],
      txtInput: "",
      shouldShowCloud: false,
      calculatedWords: [],
      shouldBeSpinning: false,
      cloudWordColor: ""
    };
  },
  methods: {
    pickRandomColor: function() {
      let colors = ["DeepPink", "RoyalBlue", "Crimson", "DodgerBlue"];
      let color = Math.floor(Math.random() * colors.length);
      // console.log(color)
      return colors[color];
    },
    showRandomQuote: function(event) {
      var vm = this;
      this.shouldBeSpinning = true;
      // console.log('spinning should be true, set to ' + this.shouldBeSpinning)
      this.quote = this.quotes[Math.floor(Math.random() * this.quotes.length)];
      setTimeout(function() {
        vm.shouldBeSpinning = false;
        // console.log(this)
        // console.log('in async, spinning should be false, set to ' + vm.shouldBeSpinning)
      }, 1000);
    },
    populateWords: function(event) {
      let self = this;
      let combinedQuotes = "";
      // Filter out junk words and symbols
      self.quotes.forEach(function(q) {
        let cleanedUp = q.replace(/<a.*>|([.,!<=>\-;/?:])/g, " ");
        cleanedUp = cleanedUp.replace(/\s{2}/g, " ");
        // Somehow sneaky unicode chars got in there. Replaced them in source but protecting against it.
        cleanedUp = cleanedUp.replace(/[\u2018\u2019]/g, "'");
        // then add them all into a giant string (vs array) for easier parsing later
        combinedQuotes = combinedQuotes + cleanedUp;
      });
      // silly or too frequent words to skip
      let skipWords = [
        "why",
        "you",
        "if",
        "all",
        "one",
        "been",
        "ever",
        "that",
        "around",
        "they",
        "away",
        "well",
        "back",
        "i've",
        "when",
        "it'd",
        "were",
        "very",
        "he's",
        "don't",
        "it's",
        "the",
        "it'll",
        "doesn't",
        "there's",
        "thing",
        "wasn't",
        "that's",
        "would",
        "where",
        "don't",
        "isn't",
        "would",
        "there",
        "didn't",
        "because",
        "you're",
        "it",
        "but",
        "by",
        "i",
        "an",
        "can",
        "me",
        "i'm",
        "was",
        "of",
        "and",
        "so",
        "is",
        "or",
        "will",
        "your",
        "do",
        "a",
        "my",
        "the",
        "be",
        "are",
        "this",
        "at",
        "they're",
        "what"
      ];
      // ok let's count em up and kick em out
      combinedQuotes
        .split(" ")
        .sort()
        .forEach(function(w, index, array) {
          if (skipWords.indexOf(w.toLowerCase()) === -1) {
            // console.log('skipWords index of ' + w.toLowerCase() + ' is ' + skipWords.indexOf(w.toLowerCase()))
            let firstIndex = array.indexOf(w);
            let lastIndex = array.lastIndexOf(w);
            let wordCount = lastIndex - firstIndex + 1;
            // try to filter out any missed but way too often used words
            if (w.match(/[A-Z]+/g) && w.length > 3) {
              let effectiveSize = 0;
              if (wordCount === 1) {
                effectiveSize = 16;
              } else if (wordCount > 1) {
                effectiveSize = 12;
              }
              self.calculatedWords.push([w, effectiveSize]);
            }
            array.splice(firstIndex, wordCount);
          }
        });
      console.log(self.calculatedWords);
    },
    filterQuotes: function(event) {
      if (this.txtInput !== "") {
        let result = this.quotes.filter(word =>
          word.toLowerCase().includes(this.txtInput.toLowerCase())
        );
        if (result.length) {
          this.quote = result[Math.floor(Math.random() * result.length)];
        } else {
          this.quote =
            "Looks like Daniel hasn't thought about " +
            this.txtInput.toLowerCase() +
            "...";
        }
      } else {
        this.quote = "Please enter a search term.";
      }
    },
    showCloud: function(event) {
      if (!this.shouldShowCloud) {
        this.shouldShowCloud = true;
        // console.log("showcloud clicked")
      } else {
        this.shouldShowCloud = false;
      }
    }
  },
  updated: function() {
    if (this.shouldShowCloud) {
      // WordCloud(document.getElementById('my_canvas'), { gridSize: 8, weightFactor: 3, list: this.calculatedWords, backgroundColor: '#333333', color: 'random-light', shape: 'square' })
    }
  },
  mounted: function() {
    let self = this;
    let url = "https://s3.amazonaws.com/danielisms-bucket/";
    let client = request.createClient(url);
    client.get("facts.json").then(function(result) {
      self.quotes = result.body;
      self.showRandomQuote();
      self.populateWords();
      self.shouldBeSpinning = false;
      self.isLoading = false;
    });
    // setTimeout(() => {
    //     this.isLoading = false
    //   }, 800)
    //
    // console.log('name ' + [VueWordCloud.name])
  }
}
</script>

<style>
/* eslint-disable */
.be-spinning {
  animation-name: ckw;
  animation-duration: 0.5s;
  /* Things added */
  /* animation-iteration-count: infinite; */
  transform-origin: 50% 50%;
  display: inline-block;
}
@keyframes ckw {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.k--group {
  display: inline-flex;
}

.k--group * {
  position: relative;
  z-index: 0;
  &:active,
  &:focus {
    z-index: 2;
  }
  &:first-child {
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
  }
  &:last-child {
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
  }
  &:not(:first-child) {
    margin-left: -1px;
  }
  &:not(:first-child):not(:last-child) {
    border-radius: 0;
  }
}

.btn-clicky:active {
  background: dark-blue;
  transform: translateY(2px);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity ease 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.speech-bubble {
  position: relative;
  background: #001cbb;
  border-radius: 0.4em;
}

.speech-bubble:after {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  width: 0;
  height: 0;
  border: 34px solid transparent;
  border-right-color: #001cbb;
  border-left: 0;
  margin-top: -34px;
  margin-left: -34px;
}
</style>



// WEBPACK FOOTER //
// src/components/DanielsBrain.vue